import { useState, useEffect, useRef, useContext } from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import { usePaginationQuestions } from './usePaginationQuestions';
import { usePaginationSearchQuestions } from './usePaginationSearchQuestions';
import { AppContext } from '../components/FaqOoi/Widget/SettingsProvider/SettingsProvider';

export const useQuestions = (initialQuestions: QuestionEntry[]) => {
  const { searchTerm } = useContext(AppContext);
  const [questionsList, setQuestionsList] = useState<QuestionEntry[]>(
    initialQuestions || [],
  );

  const bottomRef = useRef<HTMLDivElement | null>(null);

  // Manage load more logic only when not searching
  usePaginationQuestions({
    bottomRef,
    disabled: !!searchTerm,
  });

  // Manage load more logic when searching
  usePaginationSearchQuestions({
    bottomRef,
    disabled: !searchTerm,
  });

  useEffect(() => {
    setQuestionsList((prev) =>
      JSON.stringify(prev) !== JSON.stringify(initialQuestions)
        ? initialQuestions
        : prev,
    );
  }, [initialQuestions]);

  return { questionsList, bottomRef };
};
